import { useEffect, useState } from "react";
import { Card, Col } from "reactstrap";

import { useLocation } from "react-router-dom";
import CardHeaderSpan from "../../../Utils/CommonComponents/CardHeaderSpan";
import ApprovalNav from "./BorderNav";
import ApprovalTabContent from "./BorderTabContent";

import { isSystemConfigEnabled } from "../../../sharedFunctions/SystemConfig";

export default function ApprovalTabs() {
    const location = useLocation();
    const [basicTab, setBasicTab] = useState<string>('1');

    const isTabActive = (tabId: string): boolean => {
        if (tabId === '1' || tabId === '2' || tabId === '3') return true;
        if (tabId === '4' || tabId === '5') return isSystemConfigEnabled("capture_pod");
        if (tabId === '6') return isSystemConfigEnabled("support_capture");
        if (tabId === '7') return isSystemConfigEnabled("capture_closing_stock");
        if (tabId === '8') return isSystemConfigEnabled("holiday_approval_enable");
        if (tabId === '9') return isSystemConfigEnabled("enable_geo_fencing");
        return false;
    };

    useEffect(() => {
        const tab = (location.state as any)?.activeTab;
        const targetTab = tab && ['1', '2', '3', '4', '5', '6', '7', '8', '9'].includes(String(tab)) ? String(tab) : basicTab;
        if (isTabActive(targetTab)) {
            setBasicTab(targetTab);
        } else {
            setBasicTab('1');
        }
    }, [location.state]);

    return (
        <div className="page-body p-2">
            <Col xxl={12}>
                <Card>
                    <CardHeaderSpan headingClassName='py-2 px-2' back={true} heading={'Approvals'} span={'Profile'} />

                    {/* <CommonCardHeader headClass="card-no-border pb-0" title={BorderTabsTitle} subTitle={borderTabsSubTitle} /> */}
                    <div className="">
                        <ApprovalNav basicTab={basicTab} setBasicTab={setBasicTab} />
                        <ApprovalTabContent tabId={basicTab} />
                    </div>
                </Card>
            </Col>
        </div>
    )
}
